import React from 'react';
import { cn } from './cn';

/** Small labelled value tile used in detail views and dashboards. */
const StatTile = ({ icon: Icon, label, value, hint, accent = false, className }) => (
  <div className={cn('bg-page border border-line rounded-xl px-3 py-2.5 min-w-0', className)}>
    <div className="flex items-center gap-1.5 text-[11px] font-semibold uppercase tracking-wide text-muted">
      {Icon && <Icon className="w-3.5 h-3.5" />}
      <span className="truncate">{label}</span>
    </div>
    <div
      className={cn(
        'mt-0.5 text-[17px] font-semibold tabular truncate',
        accent ? 'text-accent' : 'text-primary'
      )}
      title={typeof value === 'string' ? value : undefined}
    >
      {value}
    </div>
    {hint && <div className="text-xs text-secondary truncate">{hint}</div>}
  </div>
);

export default StatTile;
